import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'kpiColumnValue',
    standalone: false
})
export class KpiColumnValuePipe implements PipeTransform {
  transform(kpiData: any, colId: string): any {
    const value = colId.split('.').reduce((acc: any, key: string) => acc && acc[key], kpiData);
    return colId === 'kpi.tasks.pickup' ? (value ?? 0) : (value ?? '');
  }
}
